import { render, staticRenderFns } from "./ChatThumbnailLayer.vue?vue&type=template&id=72713590&scoped=true&"
import script from "./ChatThumbnailLayer.vue?vue&type=script&lang=js&"
export * from "./ChatThumbnailLayer.vue?vue&type=script&lang=js&"
import style0 from "./ChatThumbnailLayer.vue?vue&type=style&index=0&id=72713590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72713590",
  null
  
)

export default component.exports